import { SettingState } from './types'

export const state: SettingState = {
    paylocationCount: 1,
    settings: {}
}